<template>
  <div>
      <stickyNav v-if="enableStickyNav" />
        <section class="blue-section section-shaped section-lg my-0">
            <div class="container pt-lg-md">
                <div class="text-center justify-content-center">
                    <h3 class="display-3 text-white">Frequently Asked Questions
                    </h3>
                    <p class="lead text-white px-5 mx-md-5">
                      We have made a list of our frequently asked questions available for our users.
                    </p>
                </div>
            </div>
        </section>

        <div class="container my-5">
            <div class="row justify-content-center">
                <div class="col-11">
                    <VueFaqAccordion 
                        :items="myItems"
                    />
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import StickyNav from '../layout/StickyHeader';
import VueFaqAccordion from 'vue-faq-accordion'
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
 
export default {
  components: {
    VueFaqAccordion,
    Tabs,
    TabPane,
    StickyNav
  },
  data () {
    return {
      enableStickyNav: null,
      myItems: [
          {
            title: 'What is the USSD code for TopupBox?',
            value: 'The USSD code for TopupBox code is *347*76#',
            category: 'Suite'
          },
          {
            title: 'Can the code *347*76# be used for all networks?',
            value: 'Yes, it is accessible to all networks',
            category: 'Suite'
          },
          {
            title: 'Who can use the code *347*76#?',
            value: 'Everyone that needs its services',
            category: 'Suite'
          },
          {
            title: 'Do I need internet access to use the code for topup?',
            value: 'No, Just dial the USSD code on your mobile phone',
            category: 'Suite'
          },
          {
            title: 'How do I create my custom page?',
            value: 'Click on the custom page on the home page or go through the enterprise page',
            category: 'Suite'
          },
          {
            title: 'How do I become a merchant or reseller?',
            value: 'Click on the Enterprise page to get started',
            category: 'Suite'
          },
          {
            title: 'How do I validate my transactions?',
            value: 'You check your transactions on our mobile app',
            category: 'Suite'
          },
          {
            title: 'Can I pay my utility Bills with TopupBox?',
            value: 'You can our USSD code or the mobile app',
            category: 'Suite'
          },
          {
            title: 'Can I generate my UNICARD codes on the website?',
            value: 'Yes, through the website or mobile app',
            category: 'Suite'
          },
          // Enterprise Questions
          {
            title: 'How do I join as an Enterprise',
            value: 'Navigate to the Enterprise page and click on the Become a merchant button. FIll the form and begin',
            category: 'Enterprise'
          },
          {
            title: 'Can I set my own rates as a dealer or merchant?',
            value: 'Yes, contact us for more',
            category: 'Enterprise'
          },
          {
            title: 'What can I sell as an Enterprise merchant?',
            value: 'Airtime, data, and bill payments across all major networks — MTN, Airtel, Glo, and 9mobile.',
            category: 'Enterprise'
          },
          {
            title: 'Do I need technical/API integration, or can I just use the dashboard?',
            value: 'Both — use the dashboard, or integrate via our API.',
            category: 'Enterprise'
          },
          {
            title: 'Can I have my own branded recharge page?',
            value: 'Yes, under your own business name.',
            category: 'Enterprise'
          },
          {
            title: 'How do I add team members to my account?',
            value: 'Go to Manage User on your dashboard and assign a role.',
            category: 'Enterprise'
          },
          {
            title: 'Is two-factor authentication required?',
            value: 'Yes, for all team members and sensitive actions like pin uploads/downloads.',
            category: 'Enterprise'
          },
          {
            title: 'How do I enable Two-Factor Authentication (2FA)?',
            value: 'Download the Google Authenticator app, then scan the QR code shown during sign-up.',
            category: 'Enterprise'
          },
          {
            title: 'Can I have multiple users on one account?',
            value: 'Yes, invite them from Manage User on your dashboard and assign a role.',
            category: 'Enterprise'
          },
          {
            title: 'Can I filter transactions by date or service?',
            value: 'Yes, use the filters on your Transactions page.',
            category: 'Enterprise'
          },
          {
            title: 'How do I get API credentials?',
            value: 'Contact us for help.',
            category: 'Enterprise'
          },
        ]
    }
  },
  mounted() {
        // console.log('Index page created')
        // console.log('Sticky Nav mounted')
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    // created() {},
    destroyed() {
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    methods: {
        handleNavDisplay() {
        var y = window.scrollY
        if (y > 100 && !this.enableStickyNav) {
            // console.log ('Display New Menu')
            this.enableStickyNav = true
        } else if (y < 100 && this.enableStickyNav) {
            // console.log('Hide sticky Nav')
            this.enableStickyNav = false
        }
        }
    }
}
</script>

<style>

</style>